import { checkUserRoutePermissions } from '~/utils/auth'

export default defineNuxtRouteMiddleware(async (to, _from) => {
  const user = useUser()

  return checkUserRoutePermissions(to, user.value)
})
